// src/next-static-analysis-workaround.ts
export * from "next/headers";
//# sourceMappingURL=next-static-analysis-workaround.js.map